import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';

import './style.scss';

const HOTKEYS_MAP = {
  enter: 'enter',
};

const AddTestSetInput = ({ addEntry, isLoading }) => {
  const [value, setValue] = useState('');
  const isNotLoading = !isLoading;

  const handleChange = useCallback(event => {
    setValue(event.target.value);
  }, []);

  const handleAddEntry = useCallback(() => {
    if (value && isNotLoading) {
      setValue('');

      addEntry({ order: 0, value });
    }
  }, [value, isNotLoading]);

  const handleHotKeys = {
    enter: handleAddEntry,
  };

  return (
    <HotKeys keyMap={HOTKEYS_MAP} handlers={handleHotKeys}>
      <div styleName="root">
        <div styleName="icon">
          <i className="icon-add-testset-raw" />
        </div>
        <input
          disabled={isLoading}
          value={value}
          placeholder="+ Token"
          onChange={handleChange}
          onBlur={handleAddEntry}
        />
      </div>
    </HotKeys>
  );
};

AddTestSetInput.propTypes = {
  addEntry: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default AddTestSetInput;
